import { render, staticRenderFns } from "./ContainerHeader.vue?vue&type=template&id=2dfbf338&scoped=true"
import script from "./ContainerHeader.vue?vue&type=script&lang=js"
export * from "./ContainerHeader.vue?vue&type=script&lang=js"
import style0 from "./ContainerHeader.css?vue&type=style&index=0&id=2dfbf338&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfbf338",
  null
  
)

export default component.exports